<template>
	<mdb-container>
		<mdb-row class="mt-4 mb-2">
			<mdb-col sm="6">
				<l-map class="d-none d-lg-block" :zoom="zoom" :center="center" style="height : 500px">
					<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
					<l-marker :lat-lng="marker"></l-marker>       
				</l-map>
			</mdb-col>
			<mdb-col sm="6">
				<form>
					<p class="h4 text-center mb-4 projectsTitle">Contact Us</p>
					<label for="defaultFormContactNameEx" class="grey-text">Your name</label>
					<input type="text" id="defaultFormContactNameEx" class="form-control" v-model="name" ref="name">
					<br>
					<label for="defaultFormContactEmailEx" class="grey-text">Your email</label>
					<input type="email" id="defaultFormContactEmailEx" class="form-control" v-model="email" ref="email">
					<br>
					<label for="defaultFormContactSubjectEx" class="grey-text">Subject</label>
					<select id="defaultFormContactSubjectEx" class="form-control" v-model="subject" ref="subject">
						<option value="tenders">Tenders</option>
						<option value="careers">Careers</option>
						<option value="live_projects">Live Projects</option>
						<option value="other">Other</option>
					</select>
					<br>
					<label for="defaultFormContactMessageEx" class="grey-text">Your message</label>
					<textarea type="text" id="defaultFormContactMessageEx" class="form-control" rows="3" v-model="message" ref="message"></textarea>
					<br>
					<label for="defaultFormContactSubjectEx" class="grey-text">Attachments</label>
					<input type="file" ref="file" multiple="multiple" class="form-control">
					<span class="grey-text">Supported Files: </span>
					<span class="grey-text" v-for="filetype in filetypes" :key="filetype">.{{ filetype }} </span>
					<div class="grey-text"><b>8MB</b> maximum filesize</div>
					<br>
					<div class="text-center mt-4">
						<button class="btn btn-outline-primary" type="button" @click="recaptcha">Send</button>
					</div>
				</form>
			</mdb-col>
		</mdb-row>
	</mdb-container>
</template>	



<script>
  import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn, mdbTextarea } from 'mdbvue';
  import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
  import axios from 'axios';
  import { VueReCaptcha } from 'vue-recaptcha-v3'
  import Vue from 'vue'

  Vue.use(VueReCaptcha, { siteKey: '6Lc7TSwbAAAAADH0kzErSJlmmUnKevQKbtmxeQWo' })

  export default {
    name: 'Contact',
    components: {
		mdbContainer,
      	mdbRow,
      	mdbCol,
      	mdbInput,
      	mdbBtn,
      	mdbTextarea,
		'l-map' : LMap,
      	'l-tile-layer' : LTileLayer,
      	'l-marker' : LMarker
    },
		data: function () {
      return {
		name: "",
		email: "",
		subject: "",
		subjectMapper: {
			"tenders" : ["commercial@foxdownconstruction.co.uk"],
			"careers" : ["admin@foxdownconstruction.co.uk"],
			"live_projects" : ["commercial@foxdownconstruction.co.uk"],
			"other" : ["admin@foxdownconstruction.co.uk"]
		},
		message: "",
		zoom: 13,
        center: [50.968279, 0.109373],
        url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: L.latLng(50.968279, 0.109373),
		filetypes: ["ppt", "xls", "xlsx", "doc", "docx", "png", "jpeg", "jpg", "gif", "pdf", "dwg"],
		maxFileSize: 8388608
    }
	},
	methods : {
		submitFiles(token) {

			if (token == "") {
				alert("Captcha Failed, please try again")
				return
			}


			let formData = new FormData();

			if (this.name == "") {
				this.$refs.name.focus();
				alert("Please provide your name");
				return;
			}

			if (this.email == "") {
				this.$refs.email.focus();
				alert("Please provide your email");
				return;
			}

			if (this.subject == "") {
				this.$refs.subject.focus();
				alert("Please select a subject");
				return;
			}

			if (this.message == "") {
				this.$refs.message.focus();
				alert("Please provide a message");
				return;
			}

			formData.append("name", this.name);
			formData.append("email", this.email);
			formData.append("subject", this.subject);
			formData.append("to", this.subjectMapper[this.subject]);
			formData.append("message", this.message);

			// add attachments
			for( var i = 0; i < this.$refs.file.files.length; i++ ){
					let file = this.$refs.file.files[i];
					
					if (file.size > this.maxFileSize){
						let message = file.name + "is too large to send"
						alert(message)
						return
					}

					var valid = false;
					for (var x=0; x<this.filetypes.length; x++) {
						let filename = file.name.toLowerCase()
						if (filename.includes(this.filetypes[x])){
							valid = true;
						}
					}

					if (valid == false) {
						let message = "Unsupported attachment " + file.name;
						alert(message);
						return
					}

					formData.append('files[' + i + ']', file);
			}

			const headers = {
				"Content-Type": "multipart/form-data",
				"X-Recaptcha-Token": token
			};

			let host = document.location.host;
			let emailUrl = "http://" + host + ":8080/email"
			// let emailUrl = "http://localhost:5000/email"

			axios({
				method: "post", 
				// url : "http://localhost:5000/email",
				url : emailUrl,
				data: formData,
				headers: headers
			}
			).then(() => {
				this.name = "";
				this.email = "";
				this.subject = "";
				this.message = "";
				this.$refs.file.value=null;
				alert("Thank you for your enquiry");
			})
			.catch((error) => {

				if (!error.response) {
					console.error("Cannot connect to email server", error)
					alert("Cannot connect to email server")
				} else {
					// http status code
					const code = error.response.status
					// response data
					const response = error.response.data
					if (code == 412) {
						console.error(error.response.data);
						let err = "Error submitting form - " + error.response.data
						alert(err);
					} else {
						console.error(error)
						alert("Error submitting form")
					}
				}
			});
		},
		async recaptcha() {
			console.debug("Starting captcha verification...")
			// (optional) Wait until recaptcha has been loaded.
			await this.$recaptchaLoaded()
			console.log(this.$recaptchaLoaded)

			// Execute reCAPTCHA with action "login".
			const token = await this.$recaptcha('login')
			if (token != "") {
				// Do stuff with the received token.
				this.submitFiles(token)
			} else {
				console.error("Captcha Failed, please try again")
				alert("Captcha Failed, please try again")
			}

  	  	}

	}
  }
</script>